<template>
  <div>
    <v-dialog
      v-if="selectedOrder"
      v-model="dialog"
      persistent
      max-width="300px"
    >
      <v-card>
        <v-card-title class="justify-center">
          Editar la Mesa
        </v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-left">
          <p>
            Hora:
            <span class="day-format">{{
              dayFormatLL(selectedOrder.time)
            }}</span>
            {{ formatTime(selectedOrder.time) }}
          </p>
          <p>
            Pedido:
            <span>{{ selectedOrder.name + weight(selectedOrder) }}</span>
          </p>
          <p>
            Email:
            <span class="value-center .text-truncate">{{
              selectedOrder.email
            }}</span>
          </p>
        </v-card-text>

        <v-card-text class="text-center">
          <div
            style="margin-left: 30px; margin-bottom: 30px; margin-right: 30px;"
          >
            <v-select
              v-model="selectedQR"
              :items="activesQR"
              style="width: 200px"
              label="Selecciona mesa"
              :item-text="qr => tableQRLabel(qr.table)"
              item-value="table"
              dense
              outlined
              hide-details
              class="table-selctor"
            ></v-select>
          </div>

          <div>
            <v-btn
              @click="cancel"
              color="light"
              text
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px"
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              @click="changeTableFromDialog"
              color="light"
              text
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px;"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "OrderEditTableDialog",
  props: ["dialog", "selectedOrder", "activesQR"],
  data() {
    return {
      selectedQR: false
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    changeTableFromDialog() {
      this.$emit("changeTableFromDialog", this.selectedQR);
    },
    weight(order) {
      return order.weight ? " \xa0\xa0" + order.weight + "Kg" : " ";
    },
    getType(order) {
      if (order.product_type_id === this.$store.state.productTypeIds.drinks) {
        return "Bebida";
      }
      return "Comida";
    }
  }
};
</script>
